import * as React from "react";
import "./MainMenuButton.scss";
import {IFeature} from "../../OverviewScreen";
import {TweenMax} from "gsap/TweenMax";
import {Back, Linear} from "gsap/EasePack";
import {IconElectricalEngine} from "./IconElectricalEngine";

export interface MainMenuButtonProps {
    active: boolean;
    feature: IFeature;
    index: number;
    isLastColumn: boolean;

    mouseEventHandler: (e: any, feature: IFeature) => void;
}

export class MainMenuButton extends React.Component<MainMenuButtonProps, {}> {

    state = {
        right: 0,
        color: '#666666',
        backgroundColor: '#f8f8f8',
        labelBottomBorder: '#d9d9d9',
    };

    stateAnimationProxy: any = {
        right: 0,
        color: '#666666',
        backgroundColor: '#f8f8f8',
        labelBottomBorder: '#d9d9d9',
    };

    stateAnimationProxySynchronize = () => {
        this.setState(
            this.stateAnimationProxy
        );

        this.updateVisibleAnimationState();
    };

    componentWillReceiveProps(nextProps: MainMenuButtonProps): void {
        if (nextProps.active != this.props.active) {
            if (nextProps.active) {
                this.addHighlight();
            } else {
                this.removeHighlight();
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        // only animation will be done
        // because this will be controlled by gsap, no rerender is needed
        return false;
    }

    addHighlight = (): void => {
        const DUR: number = .3;

        TweenMax.to(this.stateAnimationProxy, DUR,
            {
                right: -4,
                color: '#fefefc',
                backgroundColor: '#44407C',
                labelBottomBorder: '#44407C',
                ease: Back.easeOut.config(5),
                onComplete: this.stateAnimationProxySynchronize,
                onUpdate: this.stateAnimationProxySynchronize
            }
        );
    };

    removeHighlight = (): void => {
        const DUR: number = .15;

        TweenMax.to(this.stateAnimationProxy, DUR,
            {
                right: 0,
                color: '#666666',
                backgroundColor: '#f8f8f8',
                labelBottomBorder: '#d9d9d9',
                ease: Linear.easeInOut,
                onComplete: this.stateAnimationProxySynchronize,
                onUpdate: this.stateAnimationProxySynchronize
            }
        );
    };

    /**
     * Keep animation state as it should be via TweenMax updates
     */
    updateVisibleAnimationState = () => {
        TweenMax.set('.menuButton-' + this.props.index, {
            backgroundColor: this.state.backgroundColor,
        });

        TweenMax.set('.menuButton-' + this.props.index + " .mmb-label", {
            color: this.state.color,
        });

        TweenMax.set('.menuButton-' + this.props.index + " .mmb-label svg path", {
            fill: this.state.color,
        });

        TweenMax.set('.menuButton-' + this.props.index + " .arrow svg polygon", {
            fill: this.state.color,
        });

        TweenMax.set('.menuButton-' + this.props.index + " .arrow span", {
            right: this.state.right,
        });

        TweenMax.set('.menuButton-' + this.props.index + " .mmb-label", {
            borderBottomColor: this.state.labelBottomBorder
        });
    };

    render() {
        const {feature} = this.props;
        let classes: string[] = ['MainMenuButton'];
        const label: string = feature.label.toString();

        if (this.props.active) {
            classes.push('active');
        }

        classes.push('menuButton-' + this.props.index);
        if (this.props.isLastColumn) {
            classes.push('lastColumn');
        }

        this.updateVisibleAnimationState();

        return <li className={classes.join(" ")}
                   onClickCapture={(e) => this.props.mouseEventHandler(e, feature)}
                   onMouseOverCapture={(e) => this.props.mouseEventHandler(e, feature)}
                   onMouseOutCapture={(e) => this.props.mouseEventHandler(e, feature)}
                   onTouchStartCapture={(e) => this.props.mouseEventHandler(e, feature)}
                   onTouchEndCapture={(e) => this.props.mouseEventHandler(e, feature)}>
            <span className={'mmb-label'}>
                {label}
                {feature.$.electricalEngineOnly ? <IconElectricalEngine/> : null}
            </span>
            <div className={'arrow'}>
                <span>
                    <svg width="11px" height="22px" viewBox="0 0 11 22">
                        <polygon fill={this.state.color} points="0,0.6 10.1,11 0,21.4 0.3,22 11,11 0.3,0 "/>
                    </svg>
                </span>
            </div>
        </li>
    }
}
